import React from 'react';
import './popup.css'
import Cta from './cta';

const Popup = (props) => {
    return ( 
          <article className='container-popup'>
            <article className='cont2-popup'>
                <img src={props.img} alt={props.alt}></img>
                <h1 className='header-popup'>{props.header}</h1>
                <p className='para-feedback'>{props.para}</p>
                <Cta title={props.title}  to={props.to} onClick={props.onClose} />
            </article>
        </article>

     );
}
 
export default Popup;